import React, { useRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './toolbarFilter.module.scss';
import { useClickOutside } from '../../utils';
import { Button, Checkbox, Multiselect } from '../../components';

const ToolbarFilter = ({
  title,
  options,
  valueType,
  filterState,
  setFilterState,
  onSubmit,
  isActive,
  disabled,
}) => {
  const filterRef = useRef();
  const [isOpen, setIsOpen] = useClickOutside(filterRef);

  const isAllChecked =
    options.length > 0 && filterState.length === options.length;

  const handleCheckAll = () => {
    if (disabled) {
      return;
    }

    setFilterState(isAllChecked ? [] : options.map(item => item.value));
  };

  const handleToggle = () => {
    if (disabled) {
      return;
    }

    setIsOpen(!isOpen);
  };

  const handleSubmit = () => {
    if (disabled) {
      return;
    }

    setIsOpen(false);
    onSubmit();
  };

  const displayValue = () => {
    if (!filterState.length) {
      return title;
    }

    if (isAllChecked) {
      return 'Visi';
    }

    if (filterState.length === 1) {
      const selected = options.find(item => item.value === filterState[0]);
      return selected ? selected.name : title;
    }

    return `${filterState.length} pasirinkimai`;
  };

  return (
    <div className={styles.container} ref={filterRef}>
      <button
        type="button"
        className={cn(
          styles.trigger,
          isActive && styles.active,
          disabled && styles.disabled,
          !filterState.length && styles.placeholder
        )}
        onClick={handleToggle}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        {displayValue()}
      </button>

      {isOpen && (
        <div className={styles.dropdown}>
          <div className={styles.list}>
            <Checkbox
              label="Visi"
              name={`${title}-all`}
              value="-1"
              checked={isAllChecked}
              onChange={handleCheckAll}
            />

            <Multiselect
              array={options}
              type="object"
              name="name"
              value="value"
              state={filterState}
              setState={setFilterState}
              valueType={valueType}
            />
          </div>

          <div className={styles.actions}>
            <Button
              color="primary"
              type="button"
              classes={{ button: styles.confirmButton }}
              onClick={handleSubmit}
            >
              Filtruoti
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

ToolbarFilter.defaultProps = {
  disabled: false,
};

ToolbarFilter.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
  valueType: PropTypes.oneOf(['string', 'number', 'boolean']).isRequired,
  filterState: PropTypes.array.isRequired,
  setFilterState: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default ToolbarFilter;
